/**
 * ============================================================
 * Senwerk Konfigurator (Fassade ueber dem nativen Picker)  v3
 * ============================================================
 * Neu in v3:
 *  - Synchrone Property-Injektion im Klick-/Submit-Moment
 *    (Capture-Phase): schliesst die Race-Condition, bei der
 *    Horizon das Formular re-rendert und die Hidden-Inputs im
 *    80-ms-Fenster fehlten -> "Laenge exakt"/"_laenge_mm"/
 *    "Endkappe" sind jetzt bei JEDEM Warenkorb-Zugang dabei.
 *  - Keine Bereichs-/Preisstufen-Texte mehr; fester Hinweissatz
 *    und Slider-Skala werden vom Skript befuellt.
 * Weiterhin: Entwurf-/Fokus-Rettung, Stale-Render-Abwehr,
 * Warenkorb-Entdopplung, umbenennungssichere mm-Erkennung,
 * Progressive Enhancement (Fehler -> nativer Picker bleibt).
 */
(function () {
  'use strict';

  if (window.__swkKonfiguratorGeladen) return;
  window.__swkKonfiguratorGeladen = true;

  /* Preisstufen-Regel im Exakt-Modus:
     'auf' (Standard) | 'ab' | 'kaufmaennisch' */
  var PREIS_RUNDUNG = 'auf';

  /* Fenster, in dem eine Nutzereingabe Vorrang vor verspaeteten
     Theme-Re-Renders hat (Millisekunden). */
  var VORRANG_MS = 5000;

  var gedaechtnis = {};
  var initialisiert = typeof WeakSet !== 'undefined' ? new WeakSet() : null;

  function toArray(liste) {
    return Array.prototype.slice.call(liste);
  }

  /* Registrierte Injektoren: je Produkt-ID eine LISTE von Eintraegen,
     damit mehrere Widgets desselben Produkts auf einer Seite
     (z. B. Quick-View) einander nicht ueberschreiben. */
  var injektoren = {};

  function injektorRegistrieren(produktId, sektion, fn, werte) {
    var liste = (injektoren[produktId] = injektoren[produktId] || []);
    for (var i = liste.length - 1; i >= 0; i--) {
      var alt = liste[i];
      if (!alt.sektion || alt.sektion === sektion || !document.contains(alt.sektion)) {
        liste.splice(i, 1); /* veraltete/gleiche Sektion ersetzen */
      }
    }
    liste.push({ sektion: sektion, fn: fn, werte: werte });
  }

  function behandleAbsende(form) {
    if (!form || !form.getAttribute) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    var getroffen = false;
    for (var schluessel in injektoren) {
      var liste = injektoren[schluessel] || [];
      for (var i = 0; i < liste.length; i++) {
        if (liste[i].sektion && liste[i].sektion.contains(form)) {
          getroffen = true;
          try { liste[i].fn(form); } catch (e) { /* unkritisch */ }
        }
      }
    }
    if (!getroffen) {
      /* Formular ausserhalb jeder Produkt-Sektion (z. B. Sticky-
         Kaufleiste in eigener Sektion): Zuordnung ueber die
         Produkt-ID, die Shopify-Formulare mitfuehren. */
      var pidEl = form.querySelector('[name="product-id"]');
      var pid = pidEl && pidEl.value;
      var kandidaten = (pid && injektoren[pid]) || [];
      for (var k = kandidaten.length - 1; k >= 0; k--) {
        if (kandidaten[k].sektion && document.contains(kandidaten[k].sektion)) {
          try { kandidaten[k].fn(form); } catch (e) { /* unkritisch */ }
          break;
        }
      }
    }
  }

  /* ------------------------------------------------------------
     Netzwerk-Waechter (letzte Verteidigungslinie): ergaenzt fehlende
     Properties direkt im /cart/add-Request. Schliesst das Timing-
     Rennen, bei dem Horizon nach einem Variantenwechsel das Formular
     ersetzt und in derselben Ausfuehrungskette serialisiert - bevor
     unsere DOM-Re-Injektion greifen kann. Werte kommen aus dem
     geteilten Merker (zuletzt konfigurierter Stand). Vorhandene
     Properties werden NIE ueberschrieben; jeder Fehler laesst den
     Original-Request unveraendert durch. */

  function lebenderEintrag(pid) {
    var liste = (pid && injektoren[pid]) || null;
    if (!liste) {
      var ids = [];
      for (var k in injektoren) {
        if (injektoren[k] && injektoren[k].length) ids.push(k);
      }
      if (ids.length !== 1) return null; /* mehrdeutig -> nicht raten */
      liste = injektoren[ids[0]];
    }
    for (var i = liste.length - 1; i >= 0; i--) {
      if (liste[i].sektion && document.contains(liste[i].sektion) &&
          typeof liste[i].werte === 'function') {
        return liste[i];
      }
    }
    return null;
  }

  function ergaenzeInit(init) {
    if (!init || !init.body) return init;
    var body = init.body;

    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      var eintragF = lebenderEintrag(body.get ? body.get('product-id') : null);
      if (eintragF) {
        var wF = eintragF.werte();
        for (var nF in wF) {
          if (!body.has(nF)) body.append(nF, wF[nF]);
        }
      }
      return init;
    }

    if (typeof body === 'string' && body.length) {
      var erstesZeichen = body.charAt(0);
      if (erstesZeichen === '{' || erstesZeichen === '[') {
        var daten = JSON.parse(body);
        var eintragJ = lebenderEintrag(null);
        if (!eintragJ) return init;
        var wJ = eintragJ.werte();
        var propObjekt = {};
        for (var nJ in wJ) {
          var treffer = nJ.match(/^properties\[(.+)\]$/);
          if (treffer) propObjekt[treffer[1]] = wJ[nJ];
        }
        var items = daten.items || (daten.id ? [daten] : []);
        for (var iJ = 0; iJ < items.length; iJ++) {
          items[iJ].properties = items[iJ].properties || {};
          for (var pk in propObjekt) {
            if (!(pk in items[iJ].properties)) items[iJ].properties[pk] = propObjekt[pk];
          }
        }
        var neuInit = {};
        for (var kI in init) neuInit[kI] = init[kI];
        neuInit.body = JSON.stringify(daten);
        return neuInit;
      }
      if (body.indexOf('=') !== -1) {
        var usp = new URLSearchParams(body);
        var eintragU = lebenderEintrag(usp.get('product-id'));
        if (eintragU) {
          var wU = eintragU.werte();
          for (var nU in wU) {
            if (!usp.has(nU)) usp.append(nU, wU[nU]);
          }
          var neuInit2 = {};
          for (var kU in init) neuInit2[kU] = init[kU];
          neuInit2.body = usp.toString();
          return neuInit2;
        }
      }
    }
    return init;
  }

  function fetchWaechterInstallieren() {
    if (!window.fetch || window.fetch.__swkGepatcht) return;
    var original = window.fetch;
    var ersatz = function (eingabe, init) {
      try {
        if (typeof eingabe === 'string' && eingabe.indexOf('/cart/add') !== -1) {
          init = ergaenzeInit(init);
        }
      } catch (e) { /* niemals den Kauf blockieren */ }
      return original.call(this, eingabe, init);
    };
    ersatz.__swkGepatcht = true;
    window.fetch = ersatz;
  }

  document.addEventListener('submit', function (ev) {
    behandleAbsende(ev.target);
  }, true);

  document.addEventListener('click', function (ev) {
    var ziel = ev.target;
    if (!ziel || !ziel.closest) return;
    var knopf = ziel.closest('button, input[type="submit"]');
    if (!knopf) return;
    var form = knopf.form || knopf.closest('form');
    if (form) behandleAbsende(form);
  }, true);

  /* ------------------------------------------------------------
     Warenkorb-Anzeige entdoppeln (nur Positionen mit
     "Laenge exakt"-Property; selects/eigenes Widget tabu). */
  var LAENGE_MUSTER = /(?:,\s*)?\d{3,5}\s*mm\s*\(entspricht[^)]*\)/g;

  function warenkorbAufraeumen() {
    var wurzeln = document.querySelectorAll(
      'cart-drawer, cart-items, [class*="cart" i], [id*="cart" i]');
    for (var w = 0; w < wurzeln.length; w++) {
      var laeufer;
      try {
        laeufer = document.createTreeWalker(wurzeln[w], NodeFilter.SHOW_TEXT, null);
      } catch (e) { continue; }
      var knoten;
      while ((knoten = laeufer.nextNode())) {
        var text = knoten.nodeValue;
        if (!text) continue;
        var el = knoten.parentElement;
        if (!el || el.closest('select, option, script, style, noscript, [data-swk-konfigurator]')) continue;

        /* "Laenge exakt"-Zeile fett hervorheben, damit sie sich klar
           von der Preisstufen-Angabe der Variante ("x cm") abhebt. */
        if (text.indexOf('L\u00e4nge exakt') !== -1 && el.textContent.length < 60) {
          el.style.fontWeight = '700';
        }

        if (text.indexOf('entspricht') === -1) continue;
        LAENGE_MUSTER.lastIndex = 0;
        if (!LAENGE_MUSTER.test(text)) continue;
        var zeile = el.closest('li, [class*="item" i]') || el;
        if (zeile.textContent.indexOf('L\u00e4nge exakt') === -1) continue;
        LAENGE_MUSTER.lastIndex = 0;
        var neu = text.replace(LAENGE_MUSTER, '')
          .replace(/\s{2,}/g, ' ')
          .replace(/^\s*,\s*/, '')
          .replace(/\s*,\s*$/, '');
        knoten.nodeValue = neu;
      }
    }
  }

  function bereit(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function entprellen(fn, ms) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }

  var MAX_INIT_VERSUCHE = 8;

  function widgetBehandeln(w) {
    if (initialisiert && initialisiert.has(w)) {
      if (typeof w.__swkPflege === 'function') {
        try { w.__swkPflege(); } catch (e) { /* unkritisch */ }
      }
      return;
    }
    if (w.hasAttribute('data-swk-fehler')) return;
    try {
      initWidget(w);
      /* Merker auf <html>: uebersteht jeden Sektions-Morph und
         schaltet neu gerenderte Widgets per CSS sofort sichtbar. */
      document.documentElement.classList.add('swk-an');
    } catch (fehler) {
      /* Waehrend eines mehrstufigen Re-Renders kann der native
         Picker kurzzeitig fehlen -> begrenzt erneut versuchen,
         statt dauerhaft aufzugeben. */
      w.__swkVersuche = (w.__swkVersuche || 0) + 1;
      if (w.__swkVersuche >= MAX_INIT_VERSUCHE) {
        try { w.setAttribute('data-swk-fehler', '1'); } catch (e2) { /* egal */ }
        if (window.console) console.error('[senwerk-konfigurator]', fehler);
      }
    }
  }

  /* Sofort-Pass: laeuft synchron in jedem Mutations-Batch und damit
     VOR dem naechsten Paint. Aktiviert ersetzte Widgets UND pflegt
     initialisierte (nativen Picker verstecken, Sync) -> das alte
     Dropdown wird nie sichtbar gezeichnet. */
  function sofortPass() {
    var widgets = document.querySelectorAll('[data-swk-konfigurator]');
    for (var i = 0; i < widgets.length; i++) widgetBehandeln(widgets[i]);
  }

  function alleWidgetsBehandeln() {
    sofortPass();
    try { warenkorbAufraeumen(); } catch (e) { /* unkritisch */ }
  }

  bereit(function () {
    fetchWaechterInstallieren();
    alleWidgetsBehandeln();
    try {
      var spaeterPass = entprellen(alleWidgetsBehandeln, 80);
      var beobachter = new MutationObserver(function () {
        sofortPass();   /* vor dem Paint: aktivieren + verstecken */
        spaeterPass();  /* entprellt: inkl. Warenkorb-Aufraeumen */
      });
      /* documentElement statt body: uebersteht auch einen
         kompletten Body-Austausch (Review K1, SPA-Navigation). */
      beobachter.observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) { /* auch ohne Observer funktionsfaehig */ }
  });

  /* ============================================================ */

  function initWidget(widget) {
    var sektion = widget.closest('.shopify-section') || document.body;
    var produktId = widget.getAttribute('data-produkt-id') || 'produkt';
    var exaktModus = widget.getAttribute('data-exakt') === '1';
    var merker = (gedaechtnis[produktId] = gedaechtnis[produktId] || {});

    /* ---------- Laengen-Daten ---------- */
    var datenEl = widget.querySelector('[data-swk-laengen]');
    if (!datenEl) throw new Error('Laengen-Daten fehlen.');
    var laengen = JSON.parse(datenEl.textContent)
      .map(function (e) {
        /* Einheiten-Erkennung ist AUTORITATIV: die Einheit wird immer
           direkt aus dem Wertetext gelesen (mm vor cm). Die von Liquid
           vorgeparste Zahl gilt nur fuer einheitenlose Werte.
           Grund: bei Werten wie "480 cm" lieferte die Liquid-Vorstufe
           faelschlich 480 (als mm interpretiert), der fruehere
           Nur-bei-0-Fallback sprang nicht an -> Bereich schrumpfte
           auf ein Zehntel (Live-Bug nach der "bis"-Entfernung). */
        if (e && typeof e.wert === 'string') {
          var mmTreffer = e.wert.match(/(\d+(?:[\.,]\d+)?)\s*mm/i);
          var cmTreffer = e.wert.match(/(\d+(?:[\.,]\d+)?)\s*cm/i);
          if (mmTreffer) {
            e.mm = Math.round(parseFloat(mmTreffer[1].replace(',', '.')));
          } else if (cmTreffer) {
            e.mm = Math.round(parseFloat(cmTreffer[1].replace(',', '.')) * 10);
          }
        }
        return e;
      })
      .filter(function (e) { return e && isFinite(e.mm) && e.mm > 0 && typeof e.wert === 'string'; })
      .sort(function (a, b) { return a.mm - b.mm; });
    if (laengen.length < 2) throw new Error('Zu wenige Laengenstufen gefunden.');

    var laengenWerte = laengen.map(function (e) { return e.wert; });
    var minCm = Math.round(laengen[0].mm / 10);
    var maxCm = Math.round(laengen[laengen.length - 1].mm / 10);
    var stufeSchritt = Math.max(1, Math.round((laengen[1].mm - laengen[0].mm) / 10));

    /* ---------- UI-Referenzen ---------- */
    var eingabe = widget.querySelector('[data-swk-cm]');
    var slider = widget.querySelector('[data-swk-slider]');
    var minLabel = widget.querySelector('[data-swk-min-label]');
    var maxLabel = widget.querySelector('[data-swk-max-label]');
    var infoEl = widget.querySelector('[data-swk-snap]');

    /* Property-Gruppen (Endkappe + Zusatz-Optionen aus dem Metafeld):
       je Gruppe wird genau EINE Line-Item-Property injiziert,
       Schluessel = Wert des data-swk-property-Attributs. */
    var propGruppen = {};
    toArray(widget.querySelectorAll('[data-swk-property]')).forEach(function (radio) {
      var pname = radio.getAttribute('data-swk-property') || 'Endkappe';
      if (!propGruppen[pname]) propGruppen[pname] = [];
      propGruppen[pname].push(radio);
    });

    var gruppen = toArray(widget.querySelectorAll('[data-swk-gruppe]')).map(function (fs, index) {
      var pills = toArray(fs.querySelectorAll('input[type="radio"]'));
      return {
        index: index,
        fieldset: fs,
        pills: pills,
        werte: pills.map(function (p) { return p.value; }),
        aktiv: true
      };
    });

    if (!eingabe || !slider) throw new Error('Laengen-Eingabefelder fehlen.');

    eingabe.min = String(minCm);
    eingabe.max = String(maxCm);
    slider.min = String(minCm);
    slider.max = String(maxCm);
    slider.step = exaktModus ? '1' : String(stufeSchritt);
    if (minLabel) minLabel.textContent = minCm + ' cm';
    if (maxLabel) maxLabel.textContent = maxCm + ' cm';

    /* ---------- Hilfsfunktionen ---------- */

    function mengeAus(werte) {
      var m = {};
      for (var i = 0; i < werte.length; i++) m[werte[i]] = true;
      return m;
    }

    function findeControl(werte) {
      var menge = mengeAus(werte);

      /* Review K2: Das Select bzw. die Radio-Namensgruppe mit den
         MEISTEN Wert-Treffern gewinnt - schuetzt vor theoretischen
         Wert-Ueberschneidungen zwischen Optionen. */
      var selects = sektion.querySelectorAll('select');
      var bestesSelect = null;
      var besteSelectTreffer = 0;
      for (var i = 0; i < selects.length; i++) {
        if (widget.contains(selects[i])) continue;
        var opts = selects[i].options;
        var treffer = 0;
        for (var j = 0; j < opts.length; j++) {
          if (menge[opts[j].value]) treffer++;
        }
        if (treffer > besteSelectTreffer) {
          besteSelectTreffer = treffer;
          bestesSelect = selects[i];
        }
      }
      if (bestesSelect) return { typ: 'select', el: bestesSelect };

      var alleRadios = sektion.querySelectorAll('input[type="radio"]');
      var namensGruppen = {};
      for (var r = 0; r < alleRadios.length; r++) {
        var radio = alleRadios[r];
        if (widget.contains(radio) || !menge[radio.value]) continue;
        var gname = radio.name || '';
        (namensGruppen[gname] = namensGruppen[gname] || []).push(radio);
      }
      var besteGruppe = null;
      for (var gkey in namensGruppen) {
        if (!besteGruppe || namensGruppen[gkey].length > besteGruppe.length) {
          besteGruppe = namensGruppen[gkey];
        }
      }
      if (besteGruppe && besteGruppe.length) return { typ: 'radio', inputs: besteGruppe };
      return null;
    }

    function lesen(ctrl) {
      if (!ctrl) return null;
      if (ctrl.typ === 'select') return ctrl.el.value;
      for (var i = 0; i < ctrl.inputs.length; i++) {
        if (ctrl.inputs[i].checked) return ctrl.inputs[i].value;
      }
      return null;
    }

    function setzen(werte, ziel) {
      var ctrl = findeControl(werte);
      if (!ctrl) return false;
      if (ctrl.typ === 'select') {
        if (ctrl.el.value !== ziel) {
          ctrl.el.value = ziel;
          ctrl.el.dispatchEvent(new Event('input', { bubbles: true }));
          ctrl.el.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else {
        for (var i = 0; i < ctrl.inputs.length; i++) {
          if (ctrl.inputs[i].value === ziel) {
            if (!ctrl.inputs[i].checked) ctrl.inputs[i].click();
            break;
          }
        }
      }
      return true;
    }

    function findeHuelle(anker, menge) {
      var knoten = anker;
      while (knoten.parentElement &&
             knoten.parentElement !== sektion &&
             knoten.parentElement !== document.body) {
        var eltern = knoten.parentElement;
        var controls = eltern.querySelectorAll('select, button, textarea, input');
        var fremd = false;
        for (var i = 0; i < controls.length; i++) {
          var el = controls[i];
          if (el === anker) continue;
          if (widget.contains(el)) { fremd = true; }
          else if (el.tagName === 'SELECT') { fremd = true; }
          else if (el.tagName === 'BUTTON' || el.tagName === 'TEXTAREA') { fremd = true; }
          else if (el.type === 'radio') {
            if (!menge[el.value]) fremd = true;
          } else if (el.type === 'hidden') {
            /* unkritisch */
          } else {
            fremd = true;
          }
          if (fremd) break;
        }
        if (fremd) break;
        knoten = eltern;
      }
      return knoten;
    }

    function versteckeNativ(werte) {
      var ctrl = findeControl(werte);
      if (!ctrl) return;
      var anker = ctrl.typ === 'select' ? ctrl.el : ctrl.inputs[0];
      var huelle = findeHuelle(anker, mengeAus(werte));
      if (huelle && huelle !== sektion && !widget.contains(huelle)) {
        huelle.classList.add('swk-nativ-versteckt');
      }
      if (anker.id && window.CSS && typeof CSS.escape === 'function') {
        try {
          var label = sektion.querySelector('label[for="' + CSS.escape(anker.id) + '"]');
          if (label) label.classList.add('swk-nativ-versteckt');
        } catch (e) { /* unkritisch */ }
      }
    }

    /* ---------- Properties injizieren ---------- */

    function setzeHidden(form, name, wert) {
      var vorhandene = form.querySelectorAll('input[type="hidden"]');
      var inp = null;
      for (var i = 0; i < vorhandene.length; i++) {
        if (vorhandene[i].name === name) { inp = vorhandene[i]; break; }
      }
      if (!inp) {
        inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = name;
        form.appendChild(inp);
      }
      inp.value = wert;
    }

    /* Aktuellen Konfigurations-Stand als Property-Map sammeln -
       gemeinsame Quelle fuer DOM-Injektion UND Netzwerk-Waechter. */
    function sammleProperties() {
      var w = {};
      for (var pname in propGruppen) {
        if (!Object.prototype.hasOwnProperty.call(propGruppen, pname)) continue;
        var wert = (merker.props && merker.props[pname]) || null;
        if (!wert) {
          var radios = propGruppen[pname];
          for (var i = 0; i < radios.length; i++) {
            if (radios[i].checked) { wert = radios[i].value; break; }
          }
        }
        if (wert) w['properties[' + pname + ']'] = wert;
      }

      var cm = (merker.cmExakt != null) ? merker.cmExakt : parseInt(eingabe.value, 10);
      if (!isFinite(cm)) {
        var aktuellW = lesen(findeControl(laengenWerte));
        for (var j = 0; j < laengen.length; j++) {
          if (laengen[j].wert === aktuellW) { cm = Math.round(laengen[j].mm / 10); break; }
        }
      }
      if (isFinite(cm)) {
        w['properties[L\u00e4nge exakt]'] = cm + ' cm';
        w['properties[_laenge_mm]'] = String(cm * 10);
      }
      return w;
    }

    function injiziereInForm(form) {
      var w = sammleProperties();
      for (var name in w) {
        setzeHidden(form, name, w[name]);
      }
    }

    function propertySync() {
      var formulare = toArray(sektion.querySelectorAll('form[action*="/cart/add"]'));
      /* Proaktiv auch produktgleiche Formulare AUSSERHALB der Sektion
         versorgen (Sticky-Bar/Quick-View) - zusaetzlich zum
         synchronen Klick-/Submit-Weg in behandleAbsende. */
      var extern = document.querySelectorAll('form[action*="/cart/add"]');
      for (var e = 0; e < extern.length; e++) {
        if (sektion.contains(extern[e])) continue;
        var pidEl = extern[e].querySelector('[name="product-id"]');
        if (pidEl && String(pidEl.value) === String(produktId)) {
          formulare.push(extern[e]);
        }
      }
      for (var f = 0; f < formulare.length; f++) {
        injiziereInForm(formulare[f]);
      }
    }

    /* Injektor fuer den synchronen Klick-/Submit-Weg registrieren
       (ueberschreibt nach jedem Re-Render den alten Eintrag). */
    injektorRegistrieren(produktId, sektion, injiziereInForm, sammleProperties);

    /* ---------- Preisstufe ---------- */

    /* Review-Hinweis (Sonnet 4.6, Fund 4): Randfaelle sind durch die
       fruehen Returns abgedeckt; danach existiert stets ein Paar
       tiefer/hoeher mit tiefer.mm < mm < hoeher.mm oder ein exakter
       Treffer. Auch Luecken (fehlende Stufen) sind abgedeckt:
       tiefer = groesste Stufe <= mm, hoeher = kleinste Stufe >= mm.
       Logik durch 30+ Grenzwert-Tests abgesichert. */
    function stufeFuer(mm) {
      var erste = laengen[0];
      var letzte = laengen[laengen.length - 1];
      if (mm <= erste.mm) return erste;
      if (mm >= letzte.mm) return letzte;

      var tiefer = erste;
      var hoeher = letzte;
      for (var i = 0; i < laengen.length; i++) {
        if (laengen[i].mm <= mm) tiefer = laengen[i];
        if (laengen[i].mm >= mm) { hoeher = laengen[i]; break; }
      }
      if (tiefer.mm === mm) return tiefer;

      if (PREIS_RUNDUNG === 'auf') return hoeher;
      if (PREIS_RUNDUNG === 'kaufmaennisch') {
        return (hoeher.mm - mm) <= (mm - tiefer.mm) ? hoeher : tiefer;
      }
      return tiefer; /* 'ab' */
    }

    function naechsteStufe(mm) {
      var beste = laengen[0];
      for (var i = 1; i < laengen.length; i++) {
        var dNeu = Math.abs(laengen[i].mm - mm);
        var dAlt = Math.abs(beste.mm - mm);
        if (dNeu < dAlt || (dNeu === dAlt && laengen[i].mm > beste.mm)) beste = laengen[i];
      }
      return beste;
    }

    /* ---------- Anzeige ---------- */

    function sliderOptik() {
      var wert = parseFloat(slider.value);
      var anteil = ((wert - minCm) / (maxCm - minCm)) * 100;
      anteil = Math.max(0, Math.min(100, anteil));
      slider.style.background =
        'linear-gradient(to right, var(--swk-akzent) 0%, var(--swk-akzent) ' +
        anteil + '%, var(--swk-spur) ' + anteil + '%, var(--swk-spur) 100%)';
    }

    function zeigeCm(cm) {
      eingabe.value = String(cm);
      slider.value = String(cm);
      sliderOptik();
    }

    var hinweisTimer = null;
    function infoFluechtig(text) {
      if (!infoEl) return;
      infoEl.textContent = text;
      infoEl.hidden = false;
      clearTimeout(hinweisTimer);
      hinweisTimer = setTimeout(function () { infoEl.hidden = true; }, 5000);
    }

    function wirdBearbeitet() {
      var aktiv = document.activeElement;
      return (aktiv === eingabe || aktiv === slider) && merker.entwurf != null;
    }

    /* ---------- Uebernahme einer Laengen-Eingabe ---------- */

    function uebernehmen(cmRoh) {
      var cm = Math.round(parseFloat(String(cmRoh).replace(',', '.')));
      if (!isFinite(cm)) { merker.entwurf = null; syncVonNativ(); return; }
      if (cm < minCm) cm = minCm;
      if (cm > maxCm) cm = maxCm;

      merker.entwurf = null;
      merker.cmZeit = Date.now();

      if (exaktModus) {
        var stufe = stufeFuer(cm * 10);
        zeigeCm(cm);
        merker.cmExakt = cm;
        setzen(laengenWerte, stufe.wert);
        propertySync();
      } else {
        var beste = naechsteStufe(cm * 10);
        var besteCm = Math.round(beste.mm / 10);
        zeigeCm(besteCm);
        merker.cmExakt = besteCm;
        setzen(laengenWerte, beste.wert);
        propertySync();
        if (besteCm !== cm) {
          infoFluechtig(cm + ' cm wurde auf die n\u00e4chste Fertigungsstufe angepasst: ' + besteCm + ' cm.');
        } else if (infoEl) {
          infoEl.hidden = true;
        }
      }
    }

    /* ---------- UI mit dem nativen Picker abgleichen ---------- */

    function syncVonNativ() {
      var jetzt = Date.now();

      for (var g = 0; g < gruppen.length; g++) {
        var gruppe = gruppen[g];
        if (!gruppe.aktiv) continue;
        var aktuell = lesen(findeControl(gruppe.werte));
        var wahl = merker.gruppen && merker.gruppen[gruppe.index];
        var ziel = aktuell;
        if (wahl && wahl.wert !== aktuell && (jetzt - wahl.zeit) < VORRANG_MS) {
          ziel = wahl.wert;
          setzen(gruppe.werte, wahl.wert);
        }
        if (ziel) {
          for (var p = 0; p < gruppe.pills.length; p++) {
            gruppe.pills[p].checked = (gruppe.pills[p].value === ziel);
          }
        }
      }

      var aktuellL = lesen(findeControl(laengenWerte));
      var eintrag = null;
      for (var j = 0; j < laengen.length; j++) {
        if (laengen[j].wert === aktuellL) { eintrag = laengen[j]; break; }
      }
      if (!eintrag) eintrag = laengen[0];
      var stufeCm = Math.round(eintrag.mm / 10);

      var sollEintrag = (merker.cmExakt != null) ? stufeFuer(merker.cmExakt * 10) : null;
      var nutzerHatVorrang = sollEintrag &&
        merker.cmZeit && (jetzt - merker.cmZeit) < VORRANG_MS;

      if (wirdBearbeitet()) {
        /* Nutzer tippt gerade: Anzeige nicht anfassen. */
      } else if (sollEintrag && sollEintrag.mm === eintrag.mm) {
        zeigeCm(merker.cmExakt);
      } else if (nutzerHatVorrang) {
        zeigeCm(merker.cmExakt);
        setzen(laengenWerte, sollEintrag.wert);
      } else {
        zeigeCm(stufeCm);
        merker.cmExakt = stufeCm;
      }
      propertySync();
    }

    /* ---------- Events ---------- */

    eingabe.addEventListener('input', function () {
      merker.entwurf = eingabe.value;
      merker.fokus = 'eingabe';
      merker.fokusZeit = Date.now();
    });
    eingabe.addEventListener('focus', function () {
      merker.fokus = 'eingabe';
      merker.fokusZeit = Date.now();
    });
    eingabe.addEventListener('blur', function () {
      setTimeout(function () { merker.entwurf = null; merker.fokus = null; }, 200);
    });
    eingabe.addEventListener('change', function () { uebernehmen(eingabe.value); });
    eingabe.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter') { ev.preventDefault(); uebernehmen(eingabe.value); }
    });

    slider.addEventListener('pointerdown', function () {
      merker.fokus = 'slider';
      merker.fokusZeit = Date.now();
    });
    slider.addEventListener('input', function () {
      merker.entwurf = slider.value;
      merker.fokusZeit = Date.now();
      eingabe.value = slider.value;
      sliderOptik();
    });
    slider.addEventListener('change', function () { uebernehmen(slider.value); });

    gruppen.forEach(function (gruppe) {
      gruppe.pills.forEach(function (pill) {
        pill.addEventListener('change', function () {
          if (pill.checked) {
            merker.gruppen = merker.gruppen || {};
            merker.gruppen[gruppe.index] = { wert: pill.value, zeit: Date.now() };
            setzen(gruppe.werte, pill.value);
          }
        });
      });
    });

    Object.keys(propGruppen).forEach(function (pname) {
      propGruppen[pname].forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (radio.checked) {
            merker.props = merker.props || {};
            merker.props[pname] = radio.value;
            propertySync();
          }
        });
      });
    });

    if (merker.props) {
      Object.keys(propGruppen).forEach(function (pname) {
        if (merker.props[pname] == null) return;
        propGruppen[pname].forEach(function (radio) {
          radio.checked = (radio.value === merker.props[pname]);
        });
      });
    }

    /* ---------- Initial-Lauf ---------- */

    if (!findeControl(laengenWerte)) {
      throw new Error('Nativer L\u00e4ngen-Selektor nicht gefunden \u2013 Widget bleibt deaktiviert.');
    }

    gruppen.forEach(function (gruppe) {
      if (!findeControl(gruppe.werte)) {
        gruppe.aktiv = false;
        gruppe.fieldset.classList.add('swk-nativ-versteckt');
      }
    });

    versteckeNativ(laengenWerte);
    gruppen.forEach(function (gruppe) {
      if (gruppe.aktiv) versteckeNativ(gruppe.werte);
    });

    syncVonNativ();

    if (merker.entwurf != null) {
      eingabe.value = String(merker.entwurf);
    }
    if (merker.fokus && merker.fokusZeit &&
        (Date.now() - merker.fokusZeit) < 4000) {
      var fokusFrei = (document.activeElement === document.body ||
                       document.activeElement === null ||
                       widget.contains(document.activeElement));
      if (fokusFrei) {
        var ziel = merker.fokus === 'slider' ? slider : eingabe;
        try { ziel.focus({ preventScroll: true }); } catch (e) { /* unkritisch */ }
      }
    }

    widget.classList.add('swk-aktiv');

    widget.__swkPflege = function () {
      injektorRegistrieren(produktId, sektion, injiziereInForm, sammleProperties);
      versteckeNativ(laengenWerte);
      gruppen.forEach(function (gruppe) {
        if (gruppe.aktiv) versteckeNativ(gruppe.werte);
      });
      if (merker.props) {
        Object.keys(propGruppen).forEach(function (pname) {
          if (merker.props[pname] == null) return;
          propGruppen[pname].forEach(function (radio) {
            radio.checked = (radio.value === merker.props[pname]);
          });
        });
      }
      syncVonNativ();
      widget.classList.add('swk-aktiv');
    };

    if (initialisiert) initialisiert.add(widget);
  }
})();
